<template>
    <select class="form-control font-weight-bold"  id="selecComision" v-model="valor"  @change="$emit('evento', valor)">
        <option value="">Seleccione</option>
        <option v-for="d in $store.state.dataDetalleTrimovil" :key="d.Id" :value="d.Id"  >{{d.tipo }}</option>
    </select>
</template>

<script>
export default {
    name:"SelectLocales",
    props:['valor_entrada','todo'],
     data(){
        return{
            valor:'',
            data:[]
            }
        },
         beforeMount() {
           setTimeout(() => {

                this.valor = this.valor_entrada;
            }, 100);
        },
        watch: {
           
            valor_entrada(newQuestion, oldQuestion) {
                this.valor=newQuestion;
                
            }
        }

}
</script>

